var map = {
	"./app-store-black.svg": 48822,
	"./app-store.png": 79690,
	"./boots-logo.svg": 27214,
	"./bottom-cta/shape-rectangle.svg": 20639,
	"./cabinet/doctor-avatar-icon.svg": 46155,
	"./cabinet/kit-icon.svg": 49206,
	"./cabinet/phone-check-sign-icon.svg": 18801,
	"./cabinet/red-dress-bladder-pain@2x-min.png": 35078,
	"./female-seated-toilet@2x-min.jpg": 7996,
	"./flags/ie.svg": 46506,
	"./flags/uk.svg": 49222,
	"./footer/medicspot-certification-logo.jpg": 33969,
	"./goodbye/goodbye.svg": 60111,
	"./google-play-black.svg": 27156,
	"./google-play.png": 89012,
	"./healthy-logo.svg": 44008,
	"./homepage/customer-review-claudia-min.png": 70212,
	"./homepage/customer-review-claudia@2x-min.png": 72179,
	"./homepage/customer-review-magdalena-min.png": 99201,
	"./homepage/customer-review-magdalena@2x-min.png": 84421,
	"./homepage/customer-review-sarah1-min.png": 39044,
	"./homepage/customer-review-sarah1@2x-min.png": 84557,
	"./homepage/customer-review-sarah2-min.png": 12070,
	"./homepage/customer-review-sarah2@2x-min.png": 65278,
	"./homepage/hero-image.png": 95162,
	"./homepage/kit-phone-diputi@2x-min.png": 92507,
	"./homepage/kit-phone-velieve@2x-min.png": 78445,
	"./homepage/testimonial-image-min.png": 10566,
	"./homepage/ux-design-awards-gold-2021.png": 49589,
	"./info-center/play-circle-icon.svg": 68899,
	"./info-center/play-icon.svg": 2251,
	"./info-center/thumbnail-placeholder.svg": 59833,
	"./landing-page/landing-hero-desktop.png": 63104,
	"./landing-page/landing-hero-mobile.png": 58005,
	"./landing-page/testimonial-container-1.svg": 99935,
	"./landing-page/testimonial-container-2.svg": 37128,
	"./landing-page/testimonial-container-3.svg": 65766,
	"./nhs.svg": 94618,
	"./og-image-diputi-min.jpg": 67622,
	"./og-image-velieve-min.jpg": 97767,
	"./powered-by-google-on-white-hdpi.png": 44244,
	"./product/about-the-product-kit-diputi@2x-min.png": 51212,
	"./product/about-the-product-kit-velieve@2x-min.png": 99609,
	"./product/app-intro-device-diputi@2x-min.png": 69726,
	"./product/app-intro-device-velieve@2x-min.png": 8610,
	"./product/app-store-icon.png": 80608,
	"./product/device-color-board@2x-min.png": 74752,
	"./product/google-play-icon.png": 94533,
	"./product/testimonial-container-1.svg": 2142,
	"./product/testimonial-container-2.svg": 74126,
	"./product/testimonial-container-3.svg": 95563,
	"./send-off/send-off.svg": 34788,
	"./shared/quote-sign-close.svg": 89148,
	"./shared/quote-sign-open.svg": 3694,
	"./store-locator/bigMarker.svg": 54372,
	"./store-locator/marker.svg": 82855,
	"./store-locator/miniMarker.svg": 98217,
	"./store-locator/userLocation.svg": 54239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71623;